export const NEVER = 'NEVER';
export const ON_WIDGET_LOAD = 'ON_WIDGET_LOAD';
export const ON_EXIT_INTENT = 'ON_EXIT_INTENT';